module.exports = __webpack_public_path__ + "img/close2.83616683.png";